import clsx from "clsx";
import { Toaster, toast } from "sonner";

type ToastVariant = "success" | "error" | "info" | "warning";

export const showToast = (
  variant: ToastVariant,
  message: string,
  description?: string,
) => {
  toast[variant](message, description ? { description } : undefined);
};

export const AppToaster = () => (
  <Toaster
    richColors
    position="bottom-center"
    toastOptions={{
      classNames: {
        toast: "shadow-elevated",
      },
    }}
  />
);

interface BadgeProps {
  variant?: "neutral" | "success" | "warning" | "danger";
  children: React.ReactNode;
  className?: string;
}

const badgeClasses = {
  neutral: "bg-slate-100 text-ink-secondary",
  success: "bg-accent-green/10 text-accent-green",
  warning: "bg-accent-amber/10 text-accent-amber",
  danger: "bg-accent-red/10 text-accent-red",
};

export const Badge = ({ variant = "neutral", children, className }: BadgeProps) => (
  <span
    className={clsx(
      "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium",
      badgeClasses[variant],
      className,
    )}
  >
    {children}
  </span>
);
